import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { 
  Stethoscope, 
  Clock, 
  AlertTriangle, 
  CheckCircle, 
  Eye, 
  MessageSquare, 
  Smartphone, 
  TrendingUp,
  Heart,
  ArrowRight
} from 'lucide-react'
import { useGoogleAnalytics } from '../hooks/useGoogleAnalytics'

const Cirurgiao = () => {
  const { trackButtonClick } = useGoogleAnalytics();

  const handleDemoClick = () => {
    trackButtonClick('agendar_demonstracao', 'cirurgiao');
    window.open('https://calendly.com/cirurgiaautorizada-dev/30min', '_blank');
  };

  const handleAppDownloadClick = () => {
    trackButtonClick('baixar_app', 'cirurgiao');
    window.open('https://onelink.to/wsrj9h', '_blank');
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-orange-900 via-orange-800 to-orange-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="flex items-center mb-6">
                <Stethoscope className="h-12 w-12 text-orange-300 mr-4" />
                <span className="text-orange-300 text-lg font-medium">Para Cirurgiões</span>
              </div>
              <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-6">
                Foque na Medicina: Deixe a{' '}
                <span className="text-blue-400">Burocracia</span> Conosco
              </h1>
              <p className="text-xl text-orange-100 mb-8 leading-relaxed">
                Mais tempo para seus pacientes, menos preocupação com processos administrativos. 
                A Cirurgia Autorizada cuida de tudo para você.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Button 
                  size="lg" 
                  className="bg-blue-500 hover:bg-blue-600 text-white px-8 py-4 text-lg"
                  onClick={handleDemoClick}
                >
                  Agendar Demonstração
                </Button>
                <Button 
                  size="lg" 
                  variant="outline" 
                  className="border-white text-orange-900 hover:bg-gray-200 hover:text-orange-900 px-8 py-4 text-lg"
                  onClick={handleAppDownloadClick}
                >
                  Baixar App
                </Button>
              </div>
            </div>

            {/* Lista de Cards - Coluna da Direita */}
            <div className="space-y-4">
              {/* Card 1 - Primeiro cronologicamente */}
              <div className="bg-white rounded-lg shadow-lg p-4 border border-gray-200">
                <div className="flex justify-between items-start">
                  <div className="flex-1">
                    <h3 className="font-semibold text-gray-900 text-lg mb-1">Maria Silva Santos</h3>
                    <p className="text-gray-600 text-sm mb-1">Hospital São Lucas</p>
                    <p className="text-gray-600 text-sm">Cirurgia de Apendicite</p>
                  </div>
                  <div className="flex flex-col items-end space-y-2">
                    <span className="text-sm text-gray-500">08:30</span>
                    <Button 
                      size="sm" 
                      className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 text-xs"
                    >
                      Check-in
                    </Button>
                  </div>
                </div>
              </div>

              {/* Card 2 - Segundo cronologicamente */}
              <div className="bg-white rounded-lg shadow-lg p-4 border border-gray-200">
                <div className="flex justify-between items-start">
                  <div className="flex-1">
                    <h3 className="font-semibold text-gray-900 text-lg mb-1">João Carlos Oliveira</h3>
                    <p className="text-gray-600 text-sm mb-1">Hospital Santa Maria</p>
                    <p className="text-gray-600 text-sm">Cirurgia de Hérnia Inguinal</p>
                  </div>
                  <div className="flex flex-col items-end space-y-2">
                    <span className="text-sm text-gray-500">10:15</span>
                    <Button 
                      size="sm" 
                      className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 text-xs"
                    >
                      Check-in
                    </Button>
                  </div>
                </div>
              </div>

              {/* Card 3 - Terceiro cronologicamente */}
              <div className="bg-white rounded-lg shadow-lg p-4 border border-gray-200">
                <div className="flex justify-between items-start">
                  <div className="flex-1">
                    <h3 className="font-semibold text-gray-900 text-lg mb-1">Ana Paula Costa</h3>
                    <p className="text-gray-600 text-sm mb-1">Hospital Nossa Senhora</p>
                    <p className="text-gray-600 text-sm">Cirurgia de Vesícula</p>
                  </div>
                  <div className="flex flex-col items-end space-y-2">
                    <span className="text-sm text-gray-500">14:00</span>
                    <Button 
                      size="sm" 
                      className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 text-xs"
                    >
                      Check-in
                    </Button>
                  </div>
                </div>
              </div>

              {/* Card 4 - Quarto cronologicamente */}
              <div className="bg-white rounded-lg shadow-lg p-4 border border-gray-200">
                <div className="flex justify-between items-start">
                  <div className="flex-1">
                    <h3 className="font-semibold text-gray-900 text-lg mb-1">Pedro Henrique Lima</h3>
                    <p className="text-gray-600 text-sm mb-1">Hospital São José</p>
                    <p className="text-gray-600 text-sm">Cirurgia de Colecistectomia</p>
                  </div>
                  <div className="flex flex-col items-end space-y-2">
                    <span className="text-sm text-gray-500">16:45</span>
                    <Button 
                      size="sm" 
                      className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 text-xs"
                    >
                      Check-in
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefícios Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Tecnologia Que Respeita Seu Tempo e Expertise
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Desenvolvemos uma solução que mantém você informado sobre tudo que importa, 
              sem exigir que você se envolva diretamente na gestão administrativa.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Aplicativo Exclusivo para Cirurgiões</h3>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <CheckCircle className="h-6 w-6 text-green-500 mt-1" />
                  <div>
                    <h4 className="font-semibold text-gray-900">Acompanhamento em Tempo Real</h4>
                    <p className="text-gray-600">Status de autorizações, agendamentos e materiais sempre atualizados</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <CheckCircle className="h-6 w-6 text-green-500 mt-1" />
                  <div>
                    <h4 className="font-semibold text-gray-900">Notificações Inteligentes</h4>
                    <p className="text-gray-600">Receba apenas informações que realmente requerem sua atenção</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <CheckCircle className="h-6 w-6 text-green-500 mt-1" />
                  <div>
                    <h4 className="font-semibold text-gray-900">Acesso Rápido a Documentos</h4>
                    <p className="text-gray-600">Laudos, exames e informações do paciente na palma da mão</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="lg:pl-8">
              <img 
                src="/images/app.jpeg" 
                alt="Dashboard inicial aplicativo para cirurgiões" 
                className="rounded-lg shadow-lg w-1/3 mx-auto mb-4"
              />
              <p className="text-sm text-gray-500 text-center">
                Interface exclusiva para cirurgiões com foco na medicina
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <Card className="text-center p-8 border-green-200 bg-green-50">
              <CardContent className="pt-6">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Clock className="h-8 w-8 text-green-600" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Mais Tempo Para Medicina</h3>
                <p className="text-gray-600">
                  Elimine horas gastas com burocracia e dedique-se integralmente ao que você faz de melhor.
                </p>
              </CardContent>
            </Card>

            <Card className="text-center p-8 border-blue-200 bg-blue-50">
              <CardContent className="pt-6">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Eye className="h-8 w-8 text-blue-600" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Visibilidade Sem Interferência</h3>
                <p className="text-gray-600">
                  Acompanhe tudo que precisa saber sem interrupções desnecessárias no seu fluxo de trabalho.
                </p>
              </CardContent>
            </Card>

            <Card className="text-center p-8 border-orange-200 bg-orange-50">
              <CardContent className="pt-6">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <TrendingUp className="h-8 w-8 text-orange-600" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Crescimento Sustentável</h3>
                <p className="text-gray-600">
                  Escale sua prática médica sem se preocupar com a complexidade administrativa.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Funcionalidades Específicas */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Funcionalidades Pensadas Para Cirurgiões
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Cada recurso foi desenvolvido para maximizar sua eficiência sem comprometer seu foco na medicina.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <Card className="p-8">
              <CardContent className="pt-4">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
                    <Eye className="h-6 w-6 text-blue-600" />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900">Visibilidade Completa</h3>
                </div>
                <p className="text-gray-600 mb-4">
                  Acompanhe o status de cada paciente, desde a consulta inicial até a alta pós-operatória, 
                  com informações sempre atualizadas.
                </p>
                <ul className="space-y-2 text-sm text-gray-600">
                  <li className="flex items-center"><CheckCircle className="h-4 w-4 text-green-500 mr-2" />Status de autorizações</li>
                  <li className="flex items-center"><CheckCircle className="h-4 w-4 text-green-500 mr-2" />Confirmação de materiais</li>
                  <li className="flex items-center"><CheckCircle className="h-4 w-4 text-green-500 mr-2" />Agendamentos confirmados</li>
                </ul>
              </CardContent>
            </Card>

            <Card className="p-8">
              <CardContent className="pt-4">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mr-4">
                    <MessageSquare className="h-6 w-6 text-green-600" />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900">Comunicação Eficiente</h3>
                </div>
                <p className="text-gray-600 mb-4">
                  Comunique-se diretamente com sua equipe através da plataforma, 
                  mantendo controle total sobre seu fluxo de trabalho.
                </p>
                <ul className="space-y-2 text-sm text-gray-600">
                  <li className="flex items-center"><CheckCircle className="h-4 w-4 text-green-500 mr-2" />Chat direto com secretária</li>
                  <li className="flex items-center"><CheckCircle className="h-4 w-4 text-green-500 mr-2" />Notificações personalizadas</li>
                  <li className="flex items-center"><CheckCircle className="h-4 w-4 text-green-500 mr-2" />Histórico de comunicações</li>
                </ul>
              </CardContent>
            </Card>
          </div>
          
          {/* Imagem demonstrativa do calendário para cirurgiões */}
                      <div className="mt-16 text-center">
              <img 
                src="/images/cel5.png" 
                alt="Calendário de cirurgias otimizado para cirurgiões" 
                className="rounded-lg shadow-lg mx-auto max-w-2xl w-full lg:w-1/3"
              />
            <p className="text-sm text-gray-500 mt-4">
              Calendário inteligente que mantém o cirurgião sempre informado
            </p>
          </div>
        </div>
      </section>

      {/* Depoimento Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-orange-50 rounded-2xl p-8 md:p-12">
            <blockquote className="text-xl md:text-2xl text-gray-700 mb-6 italic">
              "Praticidade, segurança e menos dor de cabeça. Isso que o Cirurgia Autorizada entrega. 
              Antes dele, não conseguiamos organizar a agenda como toda a equipe cirúrgica e nem ter 
              todo o controle de todos os passos no processo de autorização-agendamento-cirurgia.
              Além de permitir a tripla checagem de material necessário entre 
              cirurgião/hospital/fornecedor. Mais segurança e praticidade."
            </blockquote>
            <div className="flex items-center justify-center">
              <div className="w-12 h-12 bg-orange-200 rounded-full flex items-center justify-center mr-4 overflow-hidden">
                <img 
                  src="/images/jonatas.png" 
                  alt="Dr. Jonatas Brito" 
                  className="w-full h-full object-cover rounded-full"
                />
              </div>
              <div className="text-left">
                <p className="font-semibold text-gray-900">Dr. Jonatas Brito - CRM/CE 13510</p>
                <p className="text-gray-600">Cirurgião de Joelho</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-orange-600 to-orange-700 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Pronto Para Revolucionar Sua Prática Médica?
          </h2>
          <p className="text-xl mb-8 text-orange-100">
            Junte-se aos cirurgiões que já descobriram como ter mais tempo para medicina e menos burocracia.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              size="lg" 
              className="bg-blue-500 hover:bg-blue-600 text-white px-8 py-4 text-lg"
              onClick={handleAppDownloadClick}
            >
              Baixar App Gratuito <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
            <Button 
              size="lg" 
              variant="outline" 
              className="border-white text-orange-900 hover:bg-gray-200 hover:text-orange-700 px-8 py-4 text-lg"
              onClick={handleDemoClick}
            >
              Agendar Demonstração
            </Button>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Cirurgiao

